(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorStructureAddPartController', EditorStructureAddPartController);

    EditorStructureAddPartController.$inject = ['$scope', '$uibModalInstance', 'defaultName'];

    function EditorStructureAddPartController($scope, $uibModalInstance, defaultName) {
        var vm = this;

        vm.name = defaultName;
        // 创建方式：import = 导入图片，size = 定义尺寸
        vm.method = null;
        vm.methods = [
            { key: 'import', title: '导入图片', description: '上传正面/反面/刀线/白墨' },
            { key: 'size', title: '定义尺寸', description: '定义画布宽高/透明背景' }
        ];

        vm.canSubmit = function () {
            return !!(vm.method && vm.name && vm.name.trim());
        };

        $scope.selectMethod = function (method) {
            vm.method = method.key;
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.next = function () {
            if (!vm.canSubmit()) {
                return;
            }
            $uibModalInstance.close({ name: vm.name.trim(), method: vm.method });
        };
    }
})();
